import { Base64 } from '../file/base64';
import { createBlob } from '../file/createBlob';

export type HtmlBase64 = string;
export type DocumentAsBase64 = { base64: Base64 };
export type HtmlDocumentAsBase64 = { htmlBase64: HtmlBase64 };
export type DocumentAsUrl = { url: string };

export enum MimeType {
   APPLICATION_PDF = 'application/pdf;base64',
   TEXT_HTML = 'text/html;base64',
}
export const createDocumentBlob = (base64: Base64, type: MimeType): Blob => createBlob(base64, type);

export const fetchDocumentBlob = async (url: string): Promise<Blob> => {
   return new Promise((resolve, reject) => {
      const request = new XMLHttpRequest();
      request.responseType = 'arraybuffer';

      request.addEventListener('error', () => {
         reject(new Error(`Error during download document. ${request.statusText}`));
      });

      request.addEventListener('load', () => {
         if (!request.response || request.responseType !== 'arraybuffer') {
            reject(new Error(`Invalid data type. ${request.responseType} for ${request.status} status.`));
         }

         const blob = new Blob([request.response], { type: 'application/pdf' });

         resolve(blob);
      });

      request.open('GET', url, true);
      request.send();
   });
};
